import { Button, SimpleMenu, useMenuState } from "@octopusdeploy/design-system-components";
import { OctoLink } from "@octopusdeploy/utilities";
import * as React from "react";
import { useExternalLinksWithAnalytics } from "~/components/Navigation/ExternalLink/useExternalLinksWithAnalytics";
export function TentacleDownloadButton() {
    const [openMenu, menuState, buttonAriaAttributes] = useMenuState();
    const menuItems = useExternalLinksWithAnalytics([
        { type: "external-link", label: "Windows (.NET Framework-dependent) 32-bit/x86 Installer", href: OctoLink.Create("LatestTentacleWinX86") },
        { type: "external-link", label: "Windows (.NET Framework-dependent) 64-bit/x64 Installer", href: OctoLink.Create("LatestTentacleWinX64") },
        { type: "external-link", label: "Windows (self-contained) 32-bit/x86 Installer", href: OctoLink.Create("LatestTentacleWinSelfContainedX86") },
        { type: "external-link", label: "Windows (self-contained) 64-bit/x64 Installer", href: OctoLink.Create("LatestTentacleWinSelfContainedX64") },
        { type: "external-link", label: "Need a custom version?", href: OctoLink.Create("TentacleDownloadPage") },
    ]);
    return (<>
            <Button importance="primary" label="Download Tentacle" onClick={openMenu} {...buttonAriaAttributes}/>
            <SimpleMenu compact={true} menuState={menuState} items={menuItems} accessibleName={"Download tentacle"}/>
        </>);
}
